module.exports = __webpack_public_path__ + "img/USDCT.2aa07327.png";